import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIdLoginAction, setIdUserAction } from "../../../../reducers";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
  MESSAGE_USER_LOGIN_UPDATE,
  SEARCH_TAB_ID_CRM,
  SEARCH_TAB_LOGIN,
  SEARCH_TAB_NIF,
  TYPE_NUMBER,
  USER_STATUS_BLOCKED,
} from "../../../../utils/constants";
import { getUsers, putLoginUpdate } from "../../../../api";
import UpdateLoginComponent from "../UserEdit/components/UpdateLoginComponent";
import { UserSearchComponent } from "./components/UsersSearchComponent";
import { useIntl } from "react-intl";
import UserActionsComponent from "./components/UserActionsComponent";
import Typography from "@material-ui/core/Typography";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CustomDataGrid from "../../../../components/custom-data-grid/CustomDataGrid";

const useStyles = makeStyles((theme) => ({
  button: theme.classes.mainButton,
  secondaryButton: theme.classes.secondaryButton,
  dialogContent: {
    display: "flex",
    gap: theme.spacing(4),
  },
  dialogActions: {
    margin: 0,
  },
  statusCell: {
    color: "red",
    display: "flex",
    gap: theme.spacing(1),
  },
}));

const UserList = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const storedIdCrm = useSelector((state) => state.idCrm);
  const storedIdUsuario = useSelector((state) => state.idUser);
  const storedTab = useSelector((state) => state.searchTab);
  const storedIdLogin = useSelector((state) => state.idLogin);
  const storedDNI = useSelector((state) => state.dni);
  const tenant = useSelector((state) => state.tenant);

  const [openUpdateLogin, setOpenUpdateLogin] = useState(false);
  const [login, setLogin] = useState("");

  const [users, setUsers] = useState(null);

  useEffect(() => {
    if (!!users?.length) {
      setUsers(null);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant]);

  const handleSetLogin = (value) => {
    setLogin(value);
  };

  const getUsersCallback = (data) => {
    setUsers(data);
  };

  const handleSubmit = () => {
    getUsers(storedTab, storedDNI, storedIdLogin, storedIdCrm, getUsersCallback);
  };

  useEffect(() => {
    if (tenant) {
      if (
        (storedTab === SEARCH_TAB_ID_CRM && storedIdCrm) ||
        (storedTab === SEARCH_TAB_LOGIN && storedIdLogin) ||
        (storedTab === SEARCH_TAB_NIF && storedDNI)
      ) {
        handleSubmit();
      } else {
        setUsers(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storedTab]);

  const handleSetIdUsuario = (idUsuario) => {
    typeof idUsuario === TYPE_NUMBER && dispatch(setIdUserAction(idUsuario.toString()));
  };

  const handleSetIdLogin = (idLogin) => {
    dispatch(setIdLoginAction(idLogin));
  };

  const handleUpdateLoginModal = (idUsuario, idLogin) => {
    handleSetIdUsuario(idUsuario);
    !!idLogin && handleSetIdLogin(idLogin);
    setOpenUpdateLogin((openUpdateLogin) => !openUpdateLogin);
  };

  const handleResponse = () => {
    handleSubmit();
  };

  const handleUpdateLoginResponse = () => {
    setOpenUpdateLogin((openUpdateLogin) => !openUpdateLogin);
    handleSetLogin("");
    handleResponse();
  };

  const handleUpdateLogin = (newLogin) => {
    const body = { nuevoLogin: newLogin };
    putLoginUpdate(storedIdCrm, storedIdUsuario, body, handleUpdateLoginResponse, {
      id: MESSAGE_USER_LOGIN_UPDATE,
      options: { idLogin: newLogin },
    });
  };

  const columns = [
    {
      field: "idLogin",
      headerName: intl.formatMessage({ id: "custom.user.login_id" }),
      flex: 1,
      sortable: false,
    },
    {
      field: "tipoUsuario.descripcion",
      headerName: intl.formatMessage({ id: "custom.user.type_description" }),
      flex: 0.5,
      sortable: false,
      valueGetter: (params) => {
        return params.row?.tipoUsuario?.descripcion || " - ";
      },
    },
    {
      field: "estado",
      headerName: intl.formatMessage({ id: "custom.user.status_description" }),
      flex: 0.5,
      renderCell: (render) => {
        const user = render.row;
        return (
          <div className={user?.estadoUsuario?.descripcion === USER_STATUS_BLOCKED ? classes.statusCell : ""}>
            {user?.estadoUsuario?.descripcion === USER_STATUS_BLOCKED && <LockOutlinedIcon fontSize={"small"} />}
            <Typography variant={"body2"}>{user?.estadoUsuario?.descripcion}</Typography>
          </div>
        );
      },
    },
    {
      field: "nif",
      headerName: intl.formatMessage({ id: "custom.user.cif_nif" }),
      sortable: false,
    },
    {
      field: "alias",
      headerName: intl.formatMessage({ id: "custom.user.alias" }),
      sortable: false,
      renderCell: (render) => <Typography variant={"body2"}>{render.row?.alias}</Typography>,
    },
    {
      field: "idUsuario",
      headerName: intl.formatMessage({ id: "custom.user.user_id" }),
      flex: 0.5,
      sortable: false,
    },
    {
      field: "idCrm",
      headerName: intl.formatMessage({ id: "custom.id_crm" }),
      flex: 0.5,
      sortable: false,
    },
    {
      field: "",
      flex: 1.5,
      sortable: false,
      renderCell: (render) => {
        return (
          <UserActionsComponent
            classes={classes}
            user={render.row}
            handleResponse={handleResponse}
            storedIdCrm={storedIdCrm}
            handleUpdateLoginModal={handleUpdateLoginModal}
          />
        );
      },
    },
  ];

  return (
    <div>
      <UserSearchComponent
        title={intl.formatMessage({ id: "menu.user_list" })}
        handleSubmit={handleSubmit}
        setter={setUsers}
      />
      {users && (
        <div>
          <CustomDataGrid columns={columns} rows={users} getRowId={(row) => row.idUsuario} />
        </div>
      )}
      <UpdateLoginComponent
        classes={classes}
        open={openUpdateLogin}
        handleClose={handleUpdateLoginModal}
        handleUpdateLogin={handleUpdateLogin}
        login={login}
        handleSetLogin={handleSetLogin}
      />
    </div>
  );
};

export default UserList;
